import { ApiQuery } from '../../core/api/entities/api-query.entity';
import { EmptyStructuredQuery } from '../../core/query/entities/empty-structured-query.constant';
import { StructuredQuery } from '../../core/query/entities/structured-query.entity';
import { UrlQueryParams } from '../../core/query/entities/url-query-params.entity';
import { UrlQueryParamsConverter } from '../../core/query/helpers/url-query-params-converter.helper';
import { LogicalOperand, Operand } from '../../public_api';
import { COMPLETABLE_TASK_FACET } from '../constants/virtual-facets.constants';

export function ExtractOnlyCompletableValue(query: ApiQuery | null, defaultValue: boolean): boolean {
    if (query === null) {
        return true;
    }
    const onlyCompletableFacet = query
        .toApiStructuredQuery()
        .Facets.find(facet => facet.DottedKey === COMPLETABLE_TASK_FACET);
    const onlyCompletableRawValue = onlyCompletableFacet?.Buckets?.[0].Value?.toLocaleLowerCase();
    if (onlyCompletableRawValue !== undefined) {
        return onlyCompletableRawValue === 'true';
    }
    const onlyCompletableQueryPart = query.queryParts.find(qp => qp.field === COMPLETABLE_TASK_FACET)?.values[0];
    return onlyCompletableQueryPart !== undefined ? onlyCompletableQueryPart === 'true' : defaultValue;
}

export function GetCompletableFacetUrlQueryParams(): UrlQueryParams {
    const structuredQuery: StructuredQuery = {
        ...EmptyStructuredQuery,
        Facets: [
            {
                LogicalOperand: LogicalOperand.And,
                DottedKey: COMPLETABLE_TASK_FACET,
                Buckets: [
                    {
                        Operand: Operand.Include,
                        Value: 'true'
                    }
                ]
            }
        ]
    };
    return UrlQueryParamsConverter.generateQueryParams(structuredQuery);
}
